import { FiPhone, FiMail } from "react-icons/fi";
import datalabLogo from '../HEADER/logo.png';
import techdome from '../Assets/techdome.png';

export default function Footer() {
  return (
    <footer className="w-full bg-gray-800 text-white py-10" id="contact">
      {/* Logos */}
      <div className="w-full flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-10">
        <img src={datalabLogo} alt="Datalab Logo" className="w-[150px] h-auto" />
      </div>

      {/* Links */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10 px-6 md:px-20">
        {/* Services */}
        <div>
          <h1 className="text-xl md:text-2xl font-semibold mb-4">Services</h1>
          <p className="text-base md:text-lg text-[#f5f5f590] mb-3">Data and Technology Consulting</p>
          <p className="text-base md:text-lg text-[#f5f5f590] mb-3">Product and Business Consulting</p>
        </div>

        

        {/* Contact */}
        <div className="flex flex-col items-center justify-center w-full">
          <h1 className="text-xl md:text-2xl font-semibold mb-4">Contact Us</h1>
          <div className="w-full flex items-center justify-center gap-2 text-base md:text-lg text-[#f5f5f590] mb-3">
            <FiPhone />
            <span>+91 9833051386</span>
          </div>
          <div className="w-full flex items-center justify-center gap-2 text-base md:text-lg text-[#f5f5f590] mb-3">
            <FiMail />
            <span>abhinav.datalabconsulting@gmail.com</span>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="border-t border-white mt-10 pt-6 px-4 text-center">
        <p className="text-sm md:text-base text-[#f5f5f590]">
          © 2022 MyDataLab. All rights Reserved.
        </p>
      </div>
    </footer>
  );
}
